'use client';

import { Box, HStack } from '@terra/ui-styled-system';
import { EntityIcon } from '../../';

export type DetectionIconProps = {
  type: 'finding' | 'signal';
  activeCount: number;
  inactiveCount: number;
};

export function DetectionIcon({
  type,
  activeCount,
  inactiveCount,
}: DetectionIconProps) {
  const hasActive = activeCount > 0;
  const hasInactive = inactiveCount > 0;

  if (hasActive && hasInactive) {
    return (
      <HStack gap={0} w="6" justifyContent="flex-end">
        <Box>
          <EntityIcon type={type} appearance="muted" />
        </Box>
        <Box ml="-2">
          <EntityIcon type={type} appearance="highlighted" />
        </Box>
      </HStack>
    );
  }

  if (hasActive) {
    return (
      <Box w="6" display="flex" justifyContent="flex-end">
        <EntityIcon type={type} appearance="highlighted" />
      </Box>
    );
  }

  return (
    <Box w="6" display="flex" justifyContent="flex-end">
      <EntityIcon type={type} appearance="muted" />
    </Box>
  );
}
